import React, { useState, useEffect } from 'react';
import supabase from '../supabase';

const NewsletterPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [showPromoCode, setShowPromoCode] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Show popup after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      // First check if email already exists
      const { data: existingEmails, error: checkError } = await supabase
        .from('mailingList')
        .select('email')
        .eq('email', email);

      if (checkError) throw checkError;

      if (existingEmails && existingEmails.length > 0) {
        setError('This email is already registered');
        return;
      }

      // If email doesn't exist, insert it
      const { error: insertError } = await supabase
        .from('mailingList')
        .insert([{ email }]);

      if (insertError) throw insertError;

      setShowPromoCode(true);
    } catch (err) {
      setError('Failed to subscribe. Please try again.');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full mx-4 relative animate-slideUp">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        {!showPromoCode ? (
          <>
            <img src="banner-popup.jpg" alt="bannerPopup" className="rounded mb-5" />
            <h2 className="text-2xl font-bold text-center mb-4">Join Our Newsletter!</h2>
            <p className="text-center mb-6">Subscribe now and get 10% off your first <br></br> <b>LOVE RUB</b> purchase!</p>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-red text-center"
                  required
                />
                {error && <p className="text-red text-sm mt-1">{error}</p>}
              </div>
              <button
                type="submit"
                className="w-full bg-red text-white py-2 rounded hover:bg-red-700 transition-colors"
              >
                Subscribe & Get 10% Off
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Thank You!</h2>
            <p className="mb-4">Your promo code is:</p>
            <div className="bg-gray-100 p-4 rounded-lg mb-4">
              <code className="text-xl font-mono">LOVERUB10</code>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Use this code at checkout to get 10% off your first purchase!
            </p>
            <button
              onClick={() => setIsVisible(false)}
              className="bg-red text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsletterPopup; 